<app-header></app-header>
<div class="content">
  <app-nav-bar></app-nav-bar>
  <router-outlet></router-outlet>
</div>
<app-busy-launcher></app-busy-launcher>
